import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { fetchGetQuery } from "../api";
import urlBuilder from "../../components/utils/dataGridURLBuilder";
import determineSorting from "../../components/utils/determineSorting";

// Custom hook to fetch paginated deminimis entries with sorting, searching and filtering
export function useGetDeminimisPagination(
  pagination,
  sorting,
  search,
  columnFilters,
) {
  const { pageIndex, pageSize } = pagination;

  // Determine sorting field and direction
  const { sortField, sortDirection } = determineSorting(sorting);

  // Filter out inactive filters (empty values)
  const activeFilters = columnFilters.filter((f) =>
    Array.isArray(f.value) ? f.value.length : f.value,
  );

  // Build URL with pagination, sorting, search and active filters
  const url = urlBuilder(
    "deminimis-pomoc/seznamPaginationV2",
    pagination,
    sortField,
    sortDirection,
    search,
    activeFilters,
  );

  return useQuery({
    queryKey: [
      "deminimis",
      pageIndex,
      pageSize,
      sortField,
      sortDirection,
      search,
      columnFilters,
    ],
    queryFn: async () => {
      return fetchGetQuery(url);
    },
    placeholderData: keepPreviousData,
    retry: 0,
  });
}

export function useGetFiltersForDeminimisDataGrid() {
  const url = "Sifrant/deminimis-filtri";
  return useQuery({
    queryKey: ["deminimis-filters"],
    queryFn: async () => {
      return fetchGetQuery(url);
    },
  });
}
